import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupVatType } from "../../../Shared/NewForms/NFLookupVatType";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import ProductDetailSkeleton from "./ProductDetailSkeleton";
import { IProductDto } from "../../../../dtos/catalogs/Products/IProductDto";
import { ProductTypeEnum } from "../../../../enums/Products/ProductTypeEnum";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";

interface IProps {
  model: IProductDto | null;
  modelUpdatedEvent: (newModel: IProductDto) => void;
}

interface ProductModel {
  id: string;
  name: string;
  uniqueCode?: string;
  createdDate?: Date;
  vendorCode?: string;
  description?: string;
  barcode?: string;
  reportingUnitId?: string;
  productType?: ProductTypeEnum;
  vatRate?: number;
  groupId?: string;
  unitForReportingId?: string;
  inventoryAccountId?: string;
  costAccountingAccountServiceId?: string;
  revenueAccountingAccountId?: string;
  costAccountingAccountGoodsId?: string;
  accruedVatAccountId?: string;
  vatId?: string;
  unitId?: string;
  import?: boolean;
  importRate?: number;
  isGroup?: boolean;
  parentId?: string;
  mainUnitId?: string;
  accountId?: string;
}

const ProductList = [
  {
    id: ProductTypeEnum.Product,
    name: "Product"
  },
  {
    id: ProductTypeEnum.Service,
    name: "Service"
  }
];

export const ProductDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [baseImage, setBaseImage] = useState<any>("");
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedOpType, setSelectedOpType] = useState(0);
  const handleTypeChange = (value: any) => {
    setSelectedOpType(value);
  };

  const uploadImage = async (e: any) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
    console.log(base64);
  };
  const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ProductModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("createdDate", model.createdDate);
      setValue("vendorCode", model.vendorCode);
      setValue("description", model.description);
      setValue("barcode", model.barcode);
      setValue("reportingUnitId", model.reportingUnitId);
      setValue("mainUnitId", model.mainUnitId);
      setValue("accountId", model.accountId);
      setValue("uniqueCode", model.uniqueCode);
      setValue("productType", model.productType);
      setValue("vatRate", model.vatRate);
      setValue("groupId", model.groupId);
      setValue("unitForReportingId", model.unitForReportingId);
      setValue("inventoryAccountId", model.inventoryAccountId);
      setValue("costAccountingAccountServiceId", model.costAccountingAccountServiceId);
      setValue("revenueAccountingAccountId", model.revenueAccountingAccountId);
      setValue("costAccountingAccountGoodsId", model.costAccountingAccountGoodsId);
      setValue("accruedVatAccountId", model.accruedVatAccountId);
      setValue("vatId", model.vatId);
      setValue("unitId", model.unitId);
      setValue("import", model.import);
      setValue("importRate", model.importRate);
      setValue("isGroup", model.isGroup);
      setValue("parentId", model.parentId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: ProductModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: IProductDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <ProductDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <div style={{ height: "600px" }}>
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

        <Col sm={6}>
          <NFLookupInput title={"Type"} fieldName={"productType"} items={ProductList} onValueChange={handleTypeChange} />
        </Col>
        <NFTabContainer index={0} currentIndex={tabIndex}>
            <Row>
              <Col sm={6}>
                <NFLookupProduct title="Choose Folder..." fieldName="parentId" />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Name"} fieldName={"name"} />
              </Col>
              <Col sm={3}>
                <NFTextInput title={"Unique code"} fieldName={"uniqueCode"} />
              </Col>
              <Col sm={3}>
                <NFDateInput title="Created Date" fieldName="createdDate" />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <NFTextInput title={"Vendor code"} fieldName={"vendorCode"} />
              </Col>
              <Col sm={6}>
                <NFTextInput title={"Bar code"} fieldName={"barcode"} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupAccount fieldName={"accountId"} title={"Account"} />
              </Col>
              <Col sm={6}>
                <NFLookupVatType title="VAT" fieldName="vatId" />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupUnit title="Unit" fieldName="unitId" />
              </Col>
              <Col sm={6}>
                <NFIntInput title="Import Rate" fieldName="importRate" />
              </Col>
            </Row>
            {selectedOpType === 0 ? (
              <Row>
                <Col sm={6}>
                  <NFLookupAccount title="Inventory Account" fieldName="inventoryAccountId" />
                </Col>
                <Col sm={6}>
                  <NFLookupAccount fieldName="revenueAccountingAccountId" title="Revenue Accouting Account" />
                </Col>
                <Col sm={6}>
                  <NFLookupAccount fieldName="costAccountingAccountGoodsId" title="Cost Accounting Account Goods" />
                </Col>
                <Col sm={6}>
                  <NFLookupAccount fieldName="accruedVatAccountId" title="ACcrued VAT account" />
                </Col>
              </Row>
            ) : (
              <Row>
                <Col sm={6}>
                  <NFLookupAccount fieldName="revenueAccountingAccountId" title="Revenue Accouting Account" />
                </Col>
                <Col sm={6}>
                  <NFLookupAccount fieldName="costAccountingAccountGoodsId" title="Cost Accounting Account Goods" />
                </Col>
                <Col sm={6}>
                  <NFLookupAccount fieldName="accruedVatAccountId" title="ACcrued VAT account" />
                </Col>
              </Row>
            )}
        </NFTabContainer>

        {/* <Tab eventKey="1" title={undefined}>
                  <div
                    className="panel-body tabs-menu-body main-content-body-right "
                    id="tab5"
                  >
                    <p>
                      cupiditate non provident voluptatum deleniti atque
                      corrupti quos dolores et quas atque corrupti quos dolores
                      et quas molestias excepturi sint occaecati cupiditate non
                      provident, similique sunt in culpa
                    </p>
                  </div>
                </Tab> */}
        {/* <Tab eventKey="Tab 05" title="Photo">
                  <div
                    className={
                      "panel-body tabs-menu-body main-content-body-right"
                    }
                  >
                    <Col sm={6}>
                      <input
                        type="file"
                        onChange={(e) => {
                          uploadImage(e);
                        }}
                        className="form-control"
                      />
                      <br></br>
                      {baseImage && <img src={baseImage} height="200px" />}
                    </Col>
                  </div>
                </Tab> */}
      </div>
    </FormProvider>
  );
};
